import React from 'react'
import SvgTooltip from 'core-system/Tooltip/SvgTooltip'
import InfoIcon from 'core-system/Icons/Misc/Info'
import palette from 'core-system/Themes/palette'

interface InfoTooltipProps {
  message: string
  label: string
}

const InfoTooltip = ({ message, label }: InfoTooltipProps) => (
  <SvgTooltip
    aria-label={label}
    role='img'
    svg={<InfoIcon color={palette.text.secondary} height={14} width={14} />}
    description={message}
    isMultiLine
    position='left'
    display='flex'
    alignItems='center'
  />
)

export default InfoTooltip
